import React from 'react';
// import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { reduxForm, getFormValues } from 'redux-form';
import { connect } from 'react-redux';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import {  ModalButtons } from '../../_Components';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const Modal = ({open, handleClose, handleSaveClick, handleCloseClick, fields, isSaving, title, formValues, width, style, content, invalid, saveDisabled, extraActions, ...props}) => {
    const save = () => handleSaveClick(formValues);
    const isSaveDisabled = typeof saveDisabled === 'function'
        ? saveDisabled(formValues)
        : (typeof saveDisabled === 'boolean' ? saveDisabled : invalid);
    const fitFields = typeof width === 'number';
    return(
        <Dialog
            maxWidth={fitFields ? false : width}
            fullWidth={!fitFields}
            sx={{
                '& .MuiDialog-paper': {
                    ...(fitFields ? { width, maxWidth: 'calc(100% - 32px)' } : {}),
                    maxHeight: 'calc(100vh - 80px)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'visible',
                    ...style,
                },
            }}
            style={style}
            open={open}
            TransitionComponent={Transition}
            disableEnforceFocus
            disableAutoFocus
            disableRestoreFocus
            onClose={handleClose}
        >
            <DialogTitle
                component="div"
                sx={{ display: 'flex', alignItems: 'center', gap: '9px', flex: 'none' }}
            >
                {title}
            </DialogTitle>
            <DialogContent sx={{ pt: '20px !important', overflow: 'visible', flex: 1, minHeight: 0 }}>
                    {fields &&
                        React.cloneElement(fields, {
                            ...props,
                            formValues,
                            context: 'form',
                        })
                    }
                    {content&&content}
            </DialogContent>
            <DialogActions sx={{ flex: 'none' }}>
                <ModalButtons handleSaveClick={save} handleCloseClick={handleCloseClick} isSaving={isSaving} disabled={isSaveDisabled}/>
                {extraActions ? <div style={{ marginLeft: 'auto' }}>{extraActions}</div> : null}
            </DialogActions>
        </Dialog>
    )
}

const mapStateToProps = (state, props) => {
    const { initial } = props;
    const formValues = getFormValues('modalForm')(state);
    return { 
        formValues,
        initialValues: initial ? initial : {}
    }
};

const enhance = compose(
    connect(mapStateToProps),
    reduxForm({
        form: 'modalForm',
        // destroyOnUnmount: true, // <------ preserve form data
        forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    }),
);

export default enhance(Modal);